import React, { VFCX } from 'react';
import styled from '@emotion/styled';

const Component: VFCX = ({ className }) => (
  <div className={className}>
    <h3 className='category-title'>資格</h3>
    <div className='category-content'>
      <p>日商簿記2級</p>
      <p>2級ファイナンシャルプランニング技能士</p>
    </div>
  </div>
);

const StyledComponent = styled(Component)`
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: var(--color-secondary-dark);
  border-radius: 1rem;

  & > h3 {
    font-size: 1.3em;
    font-weight: 600;
    padding: 1rem 0;
    border-bottom: 1px solid #fff;
  }

  & > .category-content {
    padding: 1rem;

    & > p {
      line-height: 1.5em;
    }
  }
`;

export default StyledComponent;
